<div>
    <app-business-executive-form></app-business-executive-form>
</div>
<div>
    <app-business-executive-list></app-business-executive-list>
</div>